module.exports = __webpack_public_path__ + "img/sh002-001.770921a7.jpg";